import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { SortDirection } from '@angular/material/sort';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { LabResults } from '../models/labresult.model';

@Injectable({
  providedIn: 'root',
})
export class LabresultService {
  protected labresultBaseUrl =
    this.env.APIM_BASE_URL + '/labresult-v2-service/labresult-v2/lab-results/labresults';

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: Environment,
  ) {}

  getLabResults(
    keyword: string,
    currentPage: number,
    currentPageSize: number,
    sortDirection: SortDirection,
  ): Observable<LabResults> {
    if (keyword) {
      keyword = keyword.trim();
    }

    return this.http.get<LabResults>(
      `${this.labresultBaseUrl}?keyword=${keyword}&PageNumber=${currentPage}` +
        `&PageSize=${currentPageSize}&sortDirection=${sortDirection === 'desc' ? 'Desc' : 'Asc'}`,
    );
  }
}
